import { anatomy, createMultiStyleConfigHelpers } from '@cloudbeds/payment-sdk';

const { definePartsStyle } = createMultiStyleConfigHelpers(anatomy.accordionAnatomy.keys);

// import { ComponentStyleConfig, SystemStyleFunction } from '@cloudbeds/payment-sdk';


// const baseStyle = definePartsStyle({
//   container: {
//     borderWidth: '0px',
//     marginTop: '0px',
//     marginBottom: '8px',
//     _last: {
//       borderBottomWidth: 0,
//     },
//   },
//   panel: {
//     padding: '2px',
//   },
//   button: {
//     padding: '16px',
//     bg: 'neutral.50',
//     borderRadius: '16px',
//     borderWidth: '1px',
//     borderColor: 'neutral.300',
//     backgroundColor: 'linear-gradient(0deg, #DDE0E4, #DDE0E4), linear-gradient(0deg, #F8F9FA, #F8F9FA)',
//     marginBottom: '0px',
//   },
// });


const baseStyle = definePartsStyle({
  container: {
    borderWidth: '0px',
    marginTop: '0px',
    marginBottom: '8px',
    _last: {
      borderBottomWidth: 0,
    },
  },
  panel: {
    padding: '2px',
    minHeight: '120px',
  },
  button: {
    padding: '16px',
    bg: 'neutral.50',
    borderRadius: '16px',
    borderWidth: '1px',
    borderColor: 'neutral.300',
    marginBottom: '0px',
  },
});


export const Accordion = {
  baseStyle,
};


// export const Accordion = defineMultiStyleConfig({ baseStyle });
